import { useWebSiteStore } from '@/stores/website.store'
import { useLocalizationStore } from '@/stores/localizations.store'
import axios from 'axios'

const apiClient = axios.create({
  baseURL: window.config.BASE_API,
  headers: {
    'Content-Type': 'application/json',
  },
})

apiClient.interceptors.request.use((config) => {
  if (!config.skipAuth) {
    const access_token = useWebSiteStore().accessToken
      ? `Bearer ${useWebSiteStore().accessToken}`
      : null

    if (access_token) {
      config.headers.Authorization = access_token
    }
  }

  const localizationStore = useLocalizationStore()
  if (localizationStore.selectedLanguage) {
    config.headers['Accept-Language'] = localizationStore.selectedLanguage
  }

  return config
},
(error) => Promise.reject(error)
)

export default apiClient
